import React from "react";
import requireAuth from "../auth/requireAuth";
import ReportTableGrid from "./ReportTableGrid";

class ReportList extends React.Component {
  render() {
    return (
      <div className="ui centered grid">
        <div className="ui fifteen wide column">
          <ReportTableGrid />
        </div>
      </div>
    );
  }
}

export default requireAuth(ReportList);
